/**
 * Read/write native <select> value when Choices.js controls the UI.
 *
 * @param {HTMLSelectElement|null} select
 * @return {string}
 */
export function syncChoicesSelectValue(select) {
	if (!select || select.tagName !== 'SELECT') {
		return '';
	}

	let val = String(select.value || '').trim();
	const inst = select.choices_instance || select.choicesInstance;

	if (inst?.getValue) {
		const raw = inst.getValue(true);
		const picked = Array.isArray(raw) ? raw[0] : raw;
		const fromChoices =
			picked &&
			typeof picked === 'object' &&
			picked.value !== undefined &&
			picked.value !== null
				? String(picked.value)
				: typeof picked === 'string'
				  ? picked
				  : '';
		if (fromChoices !== '') {
			val = fromChoices;
		}
	}

	if (val !== '' && select.value !== val) {
		const hasOption = Array.from(select.options).some(
			(option) => option.value === val
		);
		if (!hasOption) {
			const option = document.createElement('option');
			option.value = val;
			option.textContent = val;
			select.appendChild(option);
		}
		select.value = val;
	}

	return val;
}
